module.exports = __webpack_public_path__ + "5233158ba15908ca6df29d16e791dfa2.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/ic_locked@2x.png
// module id = 2863
// module chunks = 0